import {
  Layout,
  List,
  Monitor,
  Users,
  FileText,
  Package,
  Briefcase,
  Cpu,
  Eye,
  AlertIconKit,
  BarChartIcon,
} from "@iconsGallery"
import UserService from "../services/UserService"
import PageComponent from "./PageComponentLibrary"
import { EqualizerOutlined } from "@iconsGallery"
import { StoreEquipmentIcon } from "../IconsGallery/IconsGallery.jsx"
import {
  FrictionlessIcon,
  AutonomousStoreIcon,
  PlanogramIcon,
  SupportIcon,
  TransactionIcon,
  TaxConfigurationIcon,
  UserActivitiesIcon,
  LogViewerIcon,
  UnlockIcon,
  TransactionBrowserIcon,
} from "../IconsGallery/IconsGallery.jsx"

import { JSUtils } from "@utils"

const { location = {}, _kc = {}, globalPathName = "" } = window || {}
const { idTokenParsed = {} } = _kc || {}
const { userRole = {} } = idTokenParsed || {}

let isTenantAdmin = JSUtils?.getIsTenantAdminFlag()
let isTenantAdminForceDisable = true
let HideModule = true

const dashboardsRoutes = {
  id: "Dashboard",
  path: "/dashboard",
  readAccessPath: "Dashboard - Read",
  writeAccessPath: "Dashboard - Write",
  deleteAccessPath: "Dashboard - Delete",
  icon: <Layout />,
  component: PageComponent.SassDashboard,
  children: null,
}

/**
 *@Platform Account Config Create/Edit
 */
const createEditPlatformAccountConfig = {
  id: "Connector Settings",
  path: "/PaymentIntegration/view/:id?",
  readAccessPath: "Connector Settings.Payment Gateway Config - Read",
  writeAccessPath: "Connector Settings.Payment Gateway Config - Write",
  deleteAccessPath: "Connector Settings.Payment Gateway Config - Delete",

  icon: <Monitor />,
  component: PageComponent.CreateEditPlatformAccountConfig,
  children: null,
}
const planogramDetailRoutes = {
  id: "PlanogramDetails",
  path: "/planogram/planogramdetail/:locationId/:planogramId",
  readAccessPath: "Planogram - Read",
  writeAccessPath: "Planogram - Write",
  deleteAccessPath: "Planogram - Delete",
  icon: <Layout />,
  component: PageComponent.PlanogramDetails,
  children: null,
}
const oldDashboardsRoutes = {
  id: "oldDashboard",
  path: "/olddashboard",
  readAccessPath: "Dashboard Data.Read",
  icon: <Layout />,
  component: PageComponent.Dashboard,
  children: null,
}

let contentRoutes = {
  id: "Content",
  path: "/content",
  readAccessPath: "Content - Read",
  writeAccessPath: "Content - Write",
  deleteAccessPath: "Content - Delete",
  icon: <FileText />,
  children: [
    {
      path: "/content/shelftype",
      name: "Shelf Type",
      component: PageComponent.Digitshelf,
      readAccessPath: "Content.Shelf Type - Read",
      writeAccessPath: "Content.Shelf Type - Write",
      deleteAccessPath: "Content.Shelf Type - Delete",
    },
    {
      path: "/content/gender",
      name: "Gender",
      component: PageComponent.Gender,
      readAccessPath: "Content.Gender - Read",
      writeAccessPath: "Content.Gender - Write",
      deleteAccessPath: "Content.Gender - Delete",
    },
    {
      path: "/content/units-of-measure",
      name: "Units of Measure",
      component: PageComponent.UnitsOfMeasure,
      readAccessPath: "Content.Units of Measure - Read",
      writeAccessPath: "Content.Units of Measure - Write",
      deleteAccessPath: "Content.Units of Measure - Delete",
    },
    {
      path: "/content/barcode-types",
      name: "Barcode Types",
      component: PageComponent.BarcodeTypes,
      readAccessPath: "Content.Barcode Type - Read",
      writeAccessPath: "Content.Barcode Type - Write",
      deleteAccessPath: "Content.Barcode Type - Delete",
    },
    {
      path: "/content/tax",
      name: "Tax Code",
      component: PageComponent.Tax,
      readAccessPath: "Content.Tax Code - Read",
      writeAccessPath: "Content.Tax Code - Write",
      deleteAccessPath: "Content.Tax Code - Delete",
    },
    {
      path: "/content/payment_gateway",
      name: "Payment Gateway",
      component: PageComponent.PaymentGateWayContent,
      readAccessPath: "Content.Payment Gateway - Read",
      writeAccessPath: "Content.Payment Gateway - Write",
      deleteAccessPath: "Content.Payment Gateway - Delete",
    },
    {
      path: "/content/store_type",
      name: "Store Type",
      component: PageComponent.StoreTypeContent,
      readAccessPath: "Content.Store Type - Read",
      writeAccessPath: "Content.Store Type - Write",
      deleteAccessPath: "Content.Store Type - Delete",
    },
    {
      path: "/content/receipt_qr",
      name: "Receipt QR",
      component: PageComponent.ReceiptQR,
      readAccessPath: "Content.Receipt QR - Read",
      writeAccessPath: "Content.Receipt QR - Write",
      deleteAccessPath: "Content.Receipt QR - Delete",
    },
  ],
  component: null,
}

const masterDataLocationDetailedScreenRoutes = {
  path: "/master-data/locations/location-detailed-page/storeId=:id?",
  readAccessPath: "Master Data.Stores - Read",
  writeAccessPath: "Master Data.Stores - Write",
  deleteAccessPath: "Master Data.Stores - Delete",
  component: PageComponent.LocationTabLandingPage,
}

const masterDataLocationGroupDetailedScreenRoutes = {
  path:
    "/master-data/locations_g/groups/location-group-detailed-page/groupId=:id",
  component: PageComponent.LocationGroupDetailedPage,
  readAccessPath: "Master Data.Store Group - Read",
  writeAccessPath: "Master Data.Store Group - Write",
  deleteAccessPath: "Master Data.Store Group - Delete",
}

const masterDataProductGroupDetailedScreenRoutes = {
  path:
    "/master-data/products_g/groups/product-group-detailed-page/groupID=:id",
  readAccessPath: "Master Data.Product Group - Read",
  writeAccessPath: "Master Data.Product Group - Write",
  deleteAccessPath: "Master Data.Product Group - Delete",
  component: PageComponent.ProductGroupDetailedPage,
}

const masterDataCustomerDetailedScreenRoutes = {
  path: "/master-data/customers/customer-detailed-page/customerId=:id",
  readAccessPath: "Master Data.Customer - Read",
  writeAccessPath: "Master Data.Customer - Write",
  deleteAccessPath: "Master Data.Customer - Delete",
  component: PageComponent.CustomerDetailedPage,
}

const masterDataProductDetailedScreenRoutes = {
  path: "/master-data/products/product-detailed-page/:id",
  readAccessPath: "Master Data.Products - Read",
  writeAccessPath: "Master Data.Products - Write",
  deleteAccessPath: "Master Data.Products - Delete",
  component: PageComponent.EditProduct,
}

const masterDataInventoryDetailedScreenRoutes = {
  path: "/inventory/inventory-detailed-page/inventoryId=:id",
  component: PageComponent.InventoryDetailedPage,
  readAccessPath: "Master Data.Inventory - Read",
  writeAccessPath: "Master Data.Inventory - Write",
  deleteAccessPath: "Master Data.Inventory - Delete",
}

const masterDataAddNewAddressScreenRoutes = {
  path: "/master-data/customers/add-new-address",
  component: PageComponent.AddNewAddress,
}

const masterDataPriceDetailedScreenRoutes = {
  path: "/master-data/price/price-detailed-page/priceId=:id",
  component: PageComponent.PriceDetailedPage,
}

const masterDataLocationGroups = {
  path: "/master-data/locations_g/groups",
  component: PageComponent.Groups,
  readAccessPath: "Master Data.Store Group - Read",
  writeAccessPath: "Master Data.Store Group - Write",
  deleteAccessPath: "Master Data.Store Group - Delete",
}

const masterDataLocationHierarchy = {
  path: "/master-data/locations_h/hierarchy",
  component: PageComponent.Hierarchy,
  readAccessPath: "Master Data.Store Hierarchy - Read",
  writeAccessPath: "Master Data.Store Hierarchy - Write",
  deleteAccessPath: "Master Data.Store Hierarchy - Delete",
}

const masterDataLocationMapping = {
  path: "/master-data/locations_hm/hierarchyMapping",
  component: PageComponent.HierarchyMapping,
  readAccessPath: "Master Data.Store Hierarchy Mapping - Read",
  writeAccessPath: "Master Data.Store Hierarchy Mapping - Write",
  deleteAccessPath: "Master Data.Store Hierarchy Mapping - Delete",
}

const masterDataPosDetailedScreenRoutes = {
  path: "/frictionless-store/sdc/pos/pos-detailed-page/:locationId/:posId",
  component: PageComponent.PosDetailedScreen,
  readAccessPath: "Master Data.Locations Pos - Read",
  writeAccessPath: "Master Data.Locations Pos - Write",
  deleteAccessPath: "Master Data.Locations Pos - Delete",
}

const masterDataproductsGroups = {
  path: "/master-data/products_g/groups",
  component: PageComponent.ProductsGroups,
  readAccessPath: "Master Data.Product Group - Read",
  writeAccessPath: "Master Data.Product Group - Write",
  deleteAccessPath: "Master Data.Product Group - Delete",
}

const masterDataproductsHierarchy = {
  path: "/master-data/products_h/hierarchy",
  readAccessPath: "Master Data.Product Category - Read",
  writeAccessPath: "Master Data.Product Category - Write",
  deleteAccessPath: "Master Data.Product Category - Delete",
  component: PageComponent.ProductDataHierarchy,
}

const masterDataproductsMapping = {
  path: "/master-data/products_pm/productMapping",
  component: PageComponent.HierarchyMapping,
  readAccessPath: "Master Data.Product Category Mapping - Read",
  writeAccessPath: "Master Data.Product Category Mapping - Write",
  deleteAccessPath: "Master Data.Product Category Mapping - Delete",
}

const masterDataproductsAttribute = {
  path: "/master-data/products_attr/attribute",
  component: PageComponent.ProductAttribute,
  readAccessPath: "Master Data.Product Attributes - Read",
  writeAccessPath: "Master Data.Product Attributes - Write",
  deleteAccessPath: "Master Data.Product Attributes - Delete",
}

const masterDataInventoryAdjustments = {
  path: "/inventory/adjustments",
  component: PageComponent.InventoryAdjustments,
  readAccessPath: "Master Data.Inventory Adjustments - Read",
  writeAccessPath: "Master Data.Inventory Adjustments - Write",
  deleteAccessPath: "Master Data.Inventory Adjustments - Delete",
}

const createUpdateStorageRoutes = {
  id: "Create Location",
  path: "/master-data/Storage/createupdatestorage/:storageId?/",
  icon: <Monitor />,
  component: PageComponent.StorageLoadingPage,
  readAccessPath: "Master Data.Storage - Read",
  writeAccessPath: "Master Data.Storage - Write",
  deleteAccessPath: "Master Data.Storage - Delete",
  children: null,
}

const createLocationRoutes = {
  id: "Create Location",
  path: "/master-data/locations/create",
  icon: <Monitor />,
  component: PageComponent.CreateLocation,
  readAccessPath: "Master Data.Stores - Read",
  writeAccessPath: "Master Data.Stores - Write",
  deleteAccessPath: "Master Data.Stores - Delete",
  children: null,
}

const createPosRoutes = {
  id: "Create Pos",
  path: "/frictionless-store/sdc/pos/create/:LocationNum",
  icon: <Monitor />,
  component: PageComponent.CreateNewPos,
}

const createCustomerRoutes = {
  id: "Create Customer",
  path: "/master-data/customers/create",
  icon: <Monitor />,
  component: PageComponent.CreateCustomer,
  children: null,
}

const createProductRoutes = {
  id: "Create Product",
  path: "/master-data/products/create",
  readAccessPath: "Master Data.Products - Read",
  writeAccessPath: "Master Data.Products - Write",
  deleteAccessPath: "Master Data.Products - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateProduct,
  children: null,
}

const editProductRoutes = {
  id: "Edit Product",
  path: "/master-data/products/editProduct/:storeID/:upc",
  readAccessPath: "Master Data.Products - Read",
  writeAccessPath: "Master Data.Products - Write",
  deleteAccessPath: "Master Data.Products - Delete",
  icon: <Monitor />,
  component: PageComponent.EditProduct,
  children: null,
}

const createProductGroup = {
  id: "Create Product Group",
  path: "/master-data/products/createProductGroup/:groupID/:groupName",
  readAccessPath: "Master Data.Product Group - Read",
  writeAccessPath: "Master Data.Product Group - Write",
  deleteAccessPath: "Master Data.Product Group - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateProductGroup,
  children: null,
}

const inventoryDetails = {
  id: "Inventory Details",
  path: "/inventory/store/inventory/details/:locationId/:itemId",
  readAccessPath: "Store Inventory - Read",
  writeAccessPath: "Store Inventory - Write",
  deleteAccessPath: "Store Inventory - Delete",
  icon: <Monitor />,
  component: PageComponent.InventoryDetails,
  children: null,
}
const inventoryStorageDetails = {
  id: "Inventory Storage Details",
  path: "/inventory_storage/storage/inventoryDetails/:locationId/:itemId",
  readAccessPath: "Storage Inventory - Read",
  writeAccessPath: "Storage Inventory - Write",
  deleteAccessPath: "Storage Inventory - Delete",
  icon: <Monitor />,
  component: PageComponent.InventoryStorageDetails,
  children: null,
}

const adjustmentDetails = {
  id: "Adjustment Details",
  path:
    "/inventory/store/adjustments/view/:locationId/:locationName/:userId/:date",
  readAccessPath: "Store Inventory.Adjustments - Read",
  writeAccessPath: "Store Inventory.Adjustments - Write",
  deleteAccessPath: "Store Inventory.Adjustments - Delete",
  icon: <Monitor />,
  component: PageComponent.AdjustmentsDetails,
  children: null,
}
const adjustmentStorageDetails = {
  id: "Adjustment Details",
  path:
    "/inventory_storage/storage/adjustments/view/:locationId/:locationName/:userId/:date",
  readAccessPath: "Storage Inventory.Adjustments - Read",
  writeAccessPath: "Storage Inventory.Adjustments - Write",
  deleteAccessPath: "Storage Inventory.Adjustments - Delete",
  icon: <Monitor />,
  component: PageComponent.AdjustmentsStorageDetails,
  children: null,
}

const invetoryAdjustmentDetails = {
  id: "Invetory Adjustment Details",
  path:
    "/inventory/store/adjustments/InventoryAdjustment/:locationId/:locationName",
  readAccessPath: "Store Inventory.Adjustments - Read",
  writeAccessPath: "Store Inventory.Adjustments - Write",
  deleteAccessPath: "Store Inventory.Adjustments - Delete",
  icon: <Monitor />,
  component: PageComponent.AdjustmentsInventoryDetails,
  children: null,
}
const invetoryAdjustmentStorageDetails = {
  id: "Invetory Adjustment Details",
  path:
    "/inventory_storage/storage/adjustments/InventoryAdjustment/:locationId/:locationName",
  readAccessPath: "Storage Inventory.Adjustments - Read",
  writeAccessPath: "Storage Inventory.Adjustments - Write",
  deleteAccessPath: "Storage Inventory.Adjustments - Delete",
  icon: <Monitor />,
  component: PageComponent.AdjustmentsStorageInventoryDetails,
  children: null,
}

const invetoryCycleCountsDetails = {
  id: "Invetory CycleCounts Details",
  path:
    "/inventory/store/cycleCounts/inventoryCycleCounts/:locationId/:locationName",
  readAccessPath: "Master Data.Inventory Adjustments - Read",
  writeAccessPath: "Master Data.Inventory Adjustments - Write",
  deleteAccessPath: "Master Data.Inventory Adjustments - Delete",
  icon: <Monitor />,
  component: PageComponent.CycleCountsInventoryDetails,
  children: null,
}

const createInventoryRoutes = {
  id: "Create Inventory",
  path: "/inventory/create",
  readAccessPath: "Master Data.Inventory - Read",
  writeAccessPath: "Master Data.Inventory - Write",
  deleteAccessPath: "Master Data.Inventory - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateInventory,
  children: null,
}

const createEquipmentRoutes = {
  id: "Create Equipment",
  path: "/storeEquipment/CreateEquipment",
  icon: <Monitor />,
  component: PageComponent.CreateEquipment,
  children: null,
}

const createPriceRoutes = {
  id: "Create Price",
  path: "/master-data/price/create",
  icon: <Monitor />,
  component: PageComponent.CreatePrice,
  children: null,
}

const GroupLocationsListRoutes = {
  id: "Group Locations List",
  path: "/master-data/locations_g/groups/create",
  icon: <Monitor />,
  readAccessPath: "Master Data.Store Group - Read",
  writeAccessPath: "Master Data.Store Group - Write",
  deleteAccessPath: "Master Data.Store Group - Delete",
  component: PageComponent.GroupLocationsList,
  children: null,
}

const GroupProductCreateRoutes = {
  id: "Group Locations List",
  path: "/master-data/products_g/groups/create",
  icon: <Monitor />,
  readAccessPath: "Master Data.Product Group - Read",
  writeAccessPath: "Master Data.Product Group - Write",
  deleteAccessPath: "Master Data.Product Group - Delete",
  component: PageComponent.ProductGroupCreate,
  children: null,
}

const autonomousStoreRoutes = {
  id: "Autonomous Store",
  path: `/autonomous-store`,
  readAccessPath: "",
  writeAccessPath: "",
  deleteAccessPath: "",
  icon: <AutonomousStoreIcon />,
  childArray: [
    {
      readAccessPath: "Autonomous Store - Read",
    },
  ],
  children: [
    {
      id: "Device Config",
      name: "Device Config",
      readAccessPath: "Autonomous Store.Device Config - Read",
      writeAccessPath: "",
      deleteAccessPath: "",
      icon: "",
      component: null,
      redirect: false,
      path: ``,
      childArray: [
        {
          readAccessPath: "Autonomous Store.Device Config - Read",
        },
      ],
      children: [
        {
          path: "/autonomous-store/sdc/entryorexitgate",
          name: "Entry or Exit Gate",
          readAccessPath:
            "Autonomous Store.Device Config ---- Entry or Exit Gate - Read",
          writeAccessPath:
            "Autonomous Store.Device Config ---- Entry or Exit Gate - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Entry or Exit Gate - Delete",
          component: PageComponent.EntryorExitGateLanding,
        },
        {
          path: "/autonomous-store/sdc/paymentreaders",
          name: "Payment Readers",
          readAccessPath:
            "Autonomous Store.Device Config ---- Payment Readers - Read",
          writeAccessPath:
            "Autonomous Store.Device Config ---- Payment Readers - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Payment Readers - Delete",
          component: PageComponent.PaymentReadersLanding,
        },

        {
          path: "/autonomous-store/sdc/gondola",
          name: "Gondola",
          readAccessPath: "Autonomous Store.Device Config ---- Gondola - Read",
          writeAccessPath:
            "Autonomous Store.Device Config ---- Gondola - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Gondola - Delete",
          component: PageComponent.GondolaLanding,
        },
        {
          path: "/autonomous-store/sdc/smartShelf",
          name: "Smart Shelf",
          readAccessPath:
            "Autonomous Store.Device Config ---- Smart Shelf - Read",
          writeAccessPath:
            "Autonomous Store.Device Config ---- Smart Shelf - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Smart Shelf - Delete",
          component: PageComponent.SmartshelfLanding,
        },
        {
          path: "/autonomous-store/sdc/camera",
          name: "Camera",
          readAccessPath: "Autonomous Store.Device Config ---- Camera - Read",
          writeAccessPath: "Autonomous Store.Device Config ---- Camera - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Camera - Delete",
          component: PageComponent.CameraLanding,
        },
        {
          path: "/autonomous-store/sdc/storedevices",
          name: "Store Devices",
          readAccessPath:
            "Autonomous Store.Device Config ---- Store Devices - Read",
          writeAccessPath:
            "Autonomous Store.Device Config ---- Store Devices - Write",
          deleteAccessPath:
            "Autonomous Store.Device Config ---- Store Devices - Delete",
          component: PageComponent.StoreDevicesLanding,
        },
      ],
    },
    // {
    //   path: "/autonomous-store/planogram",
    //   name: "Planogram",
    //   readAccessPath: "Planogram - Read",
    //   writeAccessPath: "Planogram - Write",
    //   deleteAccessPath: "Planogram - Delete",
    //   component: PageComponent.PlanogramLanding,
    // },
    // {
    //   path: "/autonomous-store/livemonitoring",
    //   id: "Live Monitoring",
    //   name: "Live Monitoring",
    //   component: PageComponent.SpacePlanningList,
    //   readAccessPath: "Live Monitoring - Read",
    //   writeAccessPath: "Live Monitoring - Write",
    //   deleteAccessPath: "Live Monitoring - Delete",
    //   icon: <PlanogramIcon />,
    // },
  ],
}

const PerTenantEntryorExitGateRoutes = {
  id: "EntryorExitGates",
  path: "/autonomous-store/sdc/entryorexitgate/:tenantId",
  readAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Read",
  writeAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Write",
  deleteAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Delete",
  component: PageComponent.EntryorExitGate,
  children: null,
}

const PerTenantPaymentReadersRoutes = {
  id: "Payment Readerss",
  path: "/autonomous-store/sdc/paymentreaders/:tenantId",
  readAccessPath: "Autonomous Store.Device Config ---- Payment Readers - Read",
  writeAccessPath:
    "Autonomous Store.Device Config ---- Payment Readers - Write",
  deleteAccessPath:
    "Autonomous Store.Device Config ---- Payment Readers - Delete",
  component: PageComponent.PaymentReaders,
  children: null,
}

const PerTenantGondolasRoutes = {
  id: "Gondolas",
  path: "/autonomous-store/sdc/gondola/:tenantId",
  readAccessPath: "Autonomous Store.Device Config ---- Gondola - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Gondola - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Gondola - Delete",
  component: PageComponent.Gondola,
  children: null,
}

const PerTenantSmartShelfsRoutes = {
  id: "SmartShelfs",
  path: "/autonomous-store/sdc/smartShelf/:tenantId",
  readAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Delete",
  component: PageComponent.Smartshelf,
  children: null,
}

const PerTenantCamerasRoutes = {
  id: "Cameras",
  path: "/autonomous-store/sdc/camera/:tenantId",
  readAccessPath: "Autonomous Store.Device Config ---- Camera - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Camera - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Camera - Delete",
  component: PageComponent.Camera,
  children: null,
}

const PerTenantStoreDevicesRoutes = {
  id: "Store Devices",
  path: "/autonomous-store/sdc/storedevices/:tenantId",
  readAccessPath: "Autonomous Store.Device Config ---- Store Devices - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Store Devices - Write",
  deleteAccessPath:
    "Autonomous Store.Device Config ---- Store Devices - Delete",
  component: PageComponent.StoreDevices,
  children: null,
}
const PerTenantPlanogramRoutes = {
  id: "Planogram",
  path: "/planogram/:tenantId",
  readAccessPath: "Planogram - Read",
  writeAccessPath: "Planogram - Write",
  deleteAccessPath: "Planogram - Delete",
  component: PageComponent.Planogram,
  children: null,
}
const PerTenantLiveMonitoringRoutes = {
  id: "Live Monitoring",
  path: "/livemonitoring/:tenantId",
  readAccessPath: "Live Monitoring - Read",
  writeAccessPath: "Live Monitoring - Write",
  deleteAccessPath: "Live Monitoring - Delete",
  component: PageComponent.SpacePlanningListTenant,
  children: null,
}
const EditGondolaRoutes = {
  id: "editGondola",
  path: "/autonomous-store/sdc/gondola/gondolaDetails/:LocationNum/:gondolaId",
  readAccessPath: "Autonomous Store.Device Config ---- Gondola - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Gondola - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Gondola - Delete",
  component: PageComponent.EditGondolaDetails,
  children: null,
}

const EditCameraRoutes = {
  id: "editCamera",
  path: "/autonomous-store/sdc/camera/cameraDetails/:LocationNum/:cameraId",
  readAccessPath: "Autonomous Store.Device Config ---- Camera - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Camera - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Camera - Delete",
  component: PageComponent.EditCameraDetails,
  children: null,
}

const EditTurnstileRoutes = {
  id: "editTurnstile",
  path:
    "/autonomous-store/sdc/turnstile/turnstileDetails/:LocationNum/:turnstileId",
  readAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Delete",
  component: PageComponent.EditTurnstileDetails,
  children: null,
}
const EditEntryorExitGateRoutes = {
  id: "editEntryorExitGate",
  path:
    "/autonomous-store/sdc/entryorexitgate/entryorexitgateDetails/:LocationNum/:turnstileId",
  readAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Read",
  writeAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Write",
  deleteAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Delete",
  component: PageComponent.EditEntryorExitGateDetails,
  children: null,
}

const EditSmartShelfRoutes = {
  id: "editCamera",
  path:
    "/autonomous-store/sdc/smartShelf/smartShelfDetails/:LocationNum/:smartShelfId",
  readAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Delete",
  component: PageComponent.EditSmartShelfDetails,
  children: null,
}

const CreateTurnstile = {
  id: "createTurnstile",
  path: "/autonomous-store/sdc/turnstile/create/:LocationNum",
  readAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Turnstiles - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateTurnstileDetails,
  children: null,
}

const CreateEntryorExitGate = {
  id: "createTurnstile",
  path: "/autonomous-store/sdc/entryorexitgate/create/:LocationNum",
  readAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Read",
  writeAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Write",
  deleteAccessPath:
    "Autonomous Store.Device Config ---- Entry or Exit Gate - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEntryorExitGateDetails,
  children: null,
}

const CreateSmartShelf = {
  id: "createSmartShelf",
  path: "/autonomous-store/sdc/smartShelf/create/:LocationNum",
  readAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Smart Shelf - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateSmartShelfDetails,
  children: null,
}

const CreateCamera = {
  id: "createCamera",
  path: "/autonomous-store/sdc/camera/create/:LocationNum",
  readAccessPath: "Autonomous Store.Device Config ---- Camera - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Camera - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Camera - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateCameraDetails,
  children: null,
}

const CreateGondola = {
  id: "createGondola",
  path: "/autonomous-store/sdc/gondola/create/:LocationNum",
  readAccessPath: "Autonomous Store.Device Config ---- Gondola - Read",
  writeAccessPath: "Autonomous Store.Device Config ---- Gondola - Write",
  deleteAccessPath: "Autonomous Store.Device Config ---- Gondola - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateGondolaDetails,
  children: null,
}

const maintainPlanoGram = {
  path: "/livemonitoring/maintainPlanogram/:locationID",
  readAccessPath: "Live Monitoring - Read",
  writeAccessPath: "Live Monitoring - Write",
  deleteAccessPath: "Live Monitoring - Delete",
  name: "Maintain Planogram",
  icon: <Monitor />,
  component: PageComponent.SpacePlanning,
  children: null,
}

/**
 *@Transaction Browser
 */

const EditOrderRoutes = {
  id: "Edit Order",
  path: "/transactions/:txnId",
  icon: <Monitor />,
  component: PageComponent.EditOrderDetails,
  children: null,
  readAccessPath: "Transactions.All Transactions - Read",
  writeAccessPath: "Transactions.All Transactions - Write",
  deleteAccessPath: "Transactions.All Transactions - Delete",
}
let isEnable = true

/**
 *@Transaction  (sass)
 */
const transactionsRoutes = {
  id: "Transactions",
  path: "/Transactions",
  icon: <TransactionBrowserIcon />,
  childArray: [{ readAccessPath: "Transactions - Read" }],
  children: [
    {
      path: "/Transactions/alltransactions",
      name: "All Transactions",
      component: PageComponent.TransactionBrowser,
      readAccessPath: "Transactions.All Transactions - Read",
      writeAccessPath: "Transactions.All Transactions - Write",
      deleteAccessPath: "Transactions.All Transactions - Delete",
    },
    {
      path: "/Transactions/automatedtransactions",
      name: "Automated Transactions",
      component: PageComponent.TransactionBrowser,
      readAccessPath: "Transactions.Automated Transactions - Read",
      writeAccessPath: "Transactions.Automated Transactions - Write",
      deleteAccessPath: "Transactions.Automated Transactions - Delete",
    },
    {
      path: "/Transactions/hitltransactions",
      name: "HITL Transactions",
      component: PageComponent.TransactionBrowser,
      readAccessPath: "Transactions.HITL Transactions - Read",
      writeAccessPath: "Transactions.HITL Transactions - Write",
      deleteAccessPath: "Transactions.HITL Transactions - Delete",
    },
    {
      path: "/Transactions/disputedtransactions",
      name: "Disputed Transactions",
      component: PageComponent.TransactionBrowser,
      readAccessPath: "Transactions.Disputed Transactions - Read",
      writeAccessPath: "Transactions.Disputed Transactions - Write",
      deleteAccessPath: "Transactions.Disputed Transactions - Delete",
    },
  ],
  component: null,
}

const transactionsRoutesAll = {
  id: "Transactions",
  path: "/Transactions/:transactionTab/:tenantId",
  readAccessPath: "Transactions.All Transactions - Read",
  writeAccessPath: "Transactions.All Transactions - Write",
  deleteAccessPath: "Transactions.All Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TransactionBrowserAll,
  children: null,
}

const transactionsRoutesAutomated = {
  id: "Transactions",
  path: "/Transactions/automatedtransactions/:tenantId",
  readAccessPath: "Transactions.Automated Transactions - Read",
  writeAccessPath: "Transactions.Automated Transactions - Write",
  deleteAccessPath: "Transactions.Automated Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TransactionBrowserAll,
  children: null,
}

const transactionsRoutesHITL = {
  id: "Transactions",
  path: "/Transactions/hitltransactions/:tenantId",
  readAccessPath: "Transactions.HITL Transactions - Read",
  writeAccessPath: "Transactions.HITL Transactions - Write",
  deleteAccessPath: "Transactions.HITL Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TransactionBrowserAll,
  children: null,
}

const transactionsRoutesDisputed = {
  id: "Transactions",
  path: "/Transactions/disputedtransactions/:tenantId",
  readAccessPath: "Transactions.Disputed Transactions - Read",
  writeAccessPath: "Transactions.Disputed Transactions - Write",
  deleteAccessPath: "Transactions.Disputed Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TransactionBrowserAll,
  children: null,
}

const storeTransactionsRoutes = {
  id: "Transactions",
  path: "/tenantTransactions/:tenantId/:userType",
  readAccessPath: "Transactions.HITL Transactions - Read",
  writeAccessPath: "Transactions.HITL Transactions - Write",
  deleteAccessPath: "Transactions.HITL Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TenantTransactionDetails,
  children: null,
}

const transactionsStoresRoutes = {
  id: "Transactions",
  path: "/tenantTransactions/:tenantId",
  readAccessPath: "Transactions.HITL Transactions - Read",
  writeAccessPath: "Transactions.HITL Transactions - Write",
  deleteAccessPath: "Transactions.HITL Transactions - Delete",
  icon: <TransactionIcon />,
  component: PageComponent.TenantStores,
  children: null,
}

const AllTenantTransactionsOrder = {
  id: "Edit Order",
  path: "/Transactions/:transactionTab/:tenantId/:txnId",
  readAccessPath: "Transactions.All Transactions - Read",
  writeAccessPath: "Transactions.All Transactions - Write",
  deleteAccessPath: "Transactions.All Transactions - Delete",
  icon: <Monitor />,
  component: PageComponent.EditTenantTransactionsOrderDetails,
  children: null,
}

const AutomatedTenantTransactionsOrder = {
  id: "Edit Order",
  path: "/Transactions/automatedtransactions/:tenantId/:txnId",
  readAccessPath: "Transactions.Automated Transactions - Read",
  writeAccessPath: "Transactions.Automated Transactions - Write",
  deleteAccessPath: "Transactions.Automated Transactions - Delete",
  icon: <Monitor />,
  component: PageComponent.EditTenantTransactionsOrderDetails,
  children: null,
}

const HITLTenantTransactionsOrder = {
  id: "Edit Order",
  path: "/Transactions/hitltransactions/:tenantId/:txnId",
  readAccessPath: "Transactions.HITL Transactions - Read",
  writeAccessPath: "Transactions.HITL Transactions - Write",
  deleteAccessPath: "Transactions.HITL Transactions - Delete",
  icon: <Monitor />,
  component: PageComponent.EditTenantTransactionsOrderDetails,
  children: null,
}

const DisputedTenantTransactionsOrder = {
  id: "Edit Order",
  path: "/Transactions/disputedtransactions/:tenantId/:txnId",
  readAccessPath: "Transactions.Disputed Transactions - Read",
  writeAccessPath: "Transactions.Disputed Transactions - Write",
  deleteAccessPath: "Transactions.Disputed Transactions - Delete",
  icon: <Monitor />,
  component: PageComponent.EditTenantTransactionsOrderDetails,
  children: null,
}

/**
 *@Store User Activities
 */

const employeeDetails = isTenantAdminForceDisable
  ? {}
  : {
    id: "Store User Activities",
    path: "/employeeDetails",
    readAccessPath: "Store User Activities.Store User Activities - Read",
    icon: <UserActivitiesIcon />,
    component: PageComponent.EmployeeDetails,
    children: null,
  }

const planogramRoutes = {
  id: "Planogram",
  // id: "Tenant",
  // path: "/tenant",
  path: "/planogram",
  readAccessPath: "Planogram - Read",
  writeAccessPath: "Planogram - Write",
  deleteAccessPath: "Planogram - Delete",
  icon: <Package />,
  component: PageComponent.PlanogramLanding,
  children: null,
}

const liveMonitoringSplitRoutes = {
  path: "/livemonitoring",
  id: "Live Monitoring",
  name: "Live Monitoring",
  component: PageComponent.SpacePlanningList,
  icon: <PlanogramIcon />,
  readAccessPath: "Live Monitoring - Read",
  writeAccessPath: "Live Monitoring - Write",
  deleteAccessPath: "Live Monitoring - Delete",
  children: null,
}


/**
 *@Tenant
 */
const tenantRoutes = {
  id: "Tenant Onboarding",
  // id: "Tenant",
  // path: "/tenant",
  path: "/client_onboarding",
  readAccessPath: "Tenant Onboarding - Read",
  writeAccessPath: "Tenant Onboarding - Write",
  deleteAccessPath: "Tenant Onboarding - Delete",
  icon: <Package />,
  component: PageComponent.Tenant,
  children: null,
}

/**
 *@Tenant Settings
 * **/

const tenantSettingsRoutes = {
  id: "Organization Profile",
  path: "/organization_profile",
  readAccessPath: "Organization Profile - Read",
  writeAccessPath: "Organization Profile - Write",
  deleteAccessPath: "Organization Profile - Delete",
  icon: <Package />,
  component: PageComponent.Tenant,
  children: null,
}

/**
 *@Sub SAAS Settings
 * **/
const subSaaSAdminSettingsRoutes = {
  id: "Sub SAAS Settings",
  path: "/subsaas_settings",
  readAccessPath: "SUB-SAAS Settings - Read",
  writeAccessPath: "SUB-SAAS Settings - Write",
  deleteAccessPath: "SUB-SAAS Settings - Delete",
  icon: <Package />,
  component: PageComponent.Tenant,
  children: null,
}

const editTenantSettingsRoutes = {
  id: "Edit Tenant",
  path: "/organization_profile/view/:TenantID/:TenantType?",
  readAccessPath: "Organization Profile - Read",
  writeAccessPath: "Organization Profile - Write",
  deleteAccessPath: "Organization Profile - Delete",
  icon: <Monitor />,
  component: PageComponent.TenantCreateEdit,
  children: null,
}

/**
 *@Sub SAAS View/Edit page
 * **/
const editSubSAASSettingsRoutes = {
  id: "Edit Tenant",
  path: "/subsaas_settings/view/:TenantID/:TenantType?",
  readAccessPath: "SUB-SAAS Settings - Read",
  writeAccessPath: "SUB-SAAS Settings - Write",
  deleteAccessPath: "SUB-SAAS Settings - Delete",
  icon: <Monitor />,
  component: PageComponent.TenantCreateEdit,
  children: null,
}

/**
 *@Payment Config Create/Edit
 * **/
const createEditPaymentConfig = {
  id: "Connector Settings",
  path: "/connectorSettings/PaymentGatewayConfig/view/:id?",
  readAccessPath: "Connector Settings.Payment Gateway Config - Read",
  writeAccessPath: "Connector Settings.Payment Gateway Config - Write",
  deleteAccessPath: "Connector Settings.Payment Gateway Config - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEditPaymentConfig,
  children: null,
}

/**
 *@Remote Unlock Configuration
 * **/
const RemoteUnlockConfig = {
  id: "Remote Unlocking",
  path: "/remoteUnlocking",
  readAccessPath: "Store User Activities.Store User Activities - Read",
  icon: <UnlockIcon />,
  component: PageComponent.RemoteUnlockConfig,
  children: null,
}

/**
 *@User Management
 * **/
const userManagementRoutes = {
  id: "User Management",
  path: "/user-management",
  name: "User Management",
  icon: <Users />,
  childArray: [{ readAccessPath: "User Management - Read" }],
  children: [
    {
      id: "Sub-SaaS Permissions",
      path: "/user-management/subsaas_role_permission",
      name: "Sub-SaaS Permissions",
      readAccessPath: "User Management.Sub-SaaS Permissions - Read",
      writeAccessPath: "User Management.Sub-SaaS Permissions - Write",
      deleteAccessPath: "User Management.Sub-SaaS Permissions - Delete",
      component: PageComponent.SubsaasPermission,
    },
    {
      id: "Tenant Permissions",
      path: "/user-management/tenant_role_permission",
      name: "Tenant Permissions",
      readAccessPath: "User Management.Tenant Permissions - Read",
      writeAccessPath: "User Management.Tenant Permissions - Write",
      deleteAccessPath: "User Management.Tenant Permissions - Delete",
      component: PageComponent.TenantPermissionLanding,
      // component: PageComponent.TenantPermission,
    },

    {
      id: "Roles and Permissions",
      // path: "/user-management/tenant_roles_permission",
      path: "/user-management/rolePermission",
      name: "Roles and Permissions",
      readAccessPath: "User Management.Roles and Permissions - Read",
      writeAccessPath: "User Management.Roles and Permissions - Write",
      deleteAccessPath: "User Management.Roles and Permissions - Delete",
      component: PageComponent.Permission,
    },
    {
      id: "Users",
      // path: "/user-management/tenant_users",
      path: "/user-management/users",
      name: "Users",
      readAccessPath: "User Management.Users - Read",
      writeAccessPath: "User Management.Users - Write",
      deleteAccessPath: "User Management.Users - Delete",
      component: PageComponent.User,
    },
  ],
  component: null,
}

const rolePermissionRoutes = {
  id: "Role Permission Details",
  path:
    "/user-management/rolePermission/rolesPermissionDetails/:tenantId?/:tenantName?/:roleId?/:isDefault?",
  readAccessPath: "User Management.Roles and Permissions - Read",
  writeAccessPath: "User Management.Roles and Permissions - Write",
  deleteAccessPath: "User Management.Roles and Permissions - Delete",
  icon: <Monitor />,
  component: PageComponent.RolePermissionDetails,
  childArray: [{ readAccessPath: "User Management - Read" }],
  children: null,
}
const subsassPermissionRoutes = {
  id: "Role Permission Details",
  path:
    "/user-management/subsaas_role_permission/subsaas_rolesPermissionDetails/:tenantId?/:tenantName?/:roleId?/:isDefault?",
  readAccessPath: "User Management.Sub-SaaS Permissions - Read",
  writeAccessPath: "User Management.Sub-SaaS Permissions - Write",
  deleteAccessPath: "User Management.Sub-SaaS Permissions - Delete",
  icon: <Monitor />,
  component: PageComponent.subsaasRolePermissionDetails,
  childArray: [
    { readAccessPath: "User Management.Sub-SaaS Permissions - Read" },
  ],
  children: null,
}
const tenantPermissionRoutes = {
  id: "Role Permission Details",
  path:
    "/user-management/tenant_role_permission/tenant_rolesPermissionDetails/:tenantId?/:tenantName?/:roleId?/:isDefault?",
  readAccessPath: "User Management.Tenant Permissions - Read",
  writeAccessPath: "User Management.Tenant Permissions - Write",
  deleteAccessPath: "User Management.Tenant Permissions - Delete",
  icon: <Monitor />,
  component: PageComponent.tenantRolePermissionDetails,
  childArray: [
    { readAccessPath: "User Management.Sub-SaaS Permissions - Read" },
  ],
  children: null,
}

const createUserRoutes = {
  id: "Create User",
  path: "/user-management/users/create",
  readAccessPath: "User Management.Users - Read",
  writeAccessPath: "User Management.Users - Write",
  deleteAccessPath: "User Management.Users - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEditUser,
  childArray: [{ readAccessPath: "User Management - Read" }],
  children: null,
}

const createVendorsRoutes = {
  id: "Create User",
  path: "/master-data/Storage/Vendors/CreateVendor/:vendorId?/",
  readAccessPath: "Master Data.Vendors - Read",
  writeAccessPath: "Master Data.Vendors - Write",
  deleteAccessPath: "Master Data.Vendors - Delete",
  icon: <Monitor />,
  component: PageComponent.createVendors,
  children: null,
}

const updateVendorsRoutes = {
  id: "Update User",
  path: "/master-data/Storage/Vendors/UpdateVendor/:vendorId?/:vendorName?/",
  readAccessPath: "Master Data.Vendors - Read",
  writeAccessPath: "Master Data.Vendors - Write",
  deleteAccessPath: "Master Data.Vendors - Delete",
  icon: <Monitor />,
  component: PageComponent.updateVendors,
  children: null,
}

const createTenantRoutes = {
  id: "Create Tenant",
  // path: "/tenant/create",
  path: "/client_onboarding/create",
  readAccessPath: "Tenant Onboarding - Read",
  writeAccessPath: "Tenant Onboarding - Write",
  deleteAccessPath: "Tenant Onboarding - Delete",
  icon: <Monitor />,
  component: PageComponent.TenantCreateEdit,
  children: null,
}

const editTenantRoutes = {
  id: "Edit Tenant",
  // path: "/tenant/view/:TenantID/:TenantType?",
  path: "/client_onboarding/view/:TenantID/:TenantType?",
  readAccessPath: "Tenant Onboarding - Read",
  writeAccessPath: "Tenant Onboarding - Write",
  deleteAccessPath: "Tenant Onboarding - Delete",
  icon: <Monitor />,
  component: PageComponent.TenantCreateEdit,
  children: null,
}

const editUserRoutes = {
  id: "Edit User",
  path: "/user-management/users/view/:userID",
  readAccessPath: "User Management.Users - Read",
  writeAccessPath: "User Management.Users - Write",
  deleteAccessPath: "User Management.Users - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEditUser,
  children: null,
}

/**
 *@Tax Configuration
 */
const serviceIntergrationRoutes = {
  id: "Service Integration",
  path: "/configuration",
  name: "Tax Configuration",
  icon: <TaxConfigurationIcon />,
  readAccessPath: "",
  childArray: [{ readAccessPath: "Service Integration - Read" }],
  children: [
    {
      path: "/configuration/taxProvider",
      name: "Tax Integration",
      readAccessPath: "Service Integration.Tax Integration - Read",
      writeAccessPath: "Service Integration.Tax Integration - Write",
      deleteAccessPath: "Service Integration.Tax Integration - Delete",
      component: PageComponent.TaxProvider,
    },
    {
      name: "Payment Integration",
      path: "/configuration/paymentintegration",
      readAccessPath: "Service Integration.Payment Integration - Read",
      writeAccessPath: "Service Integration.Payment Integration - Write",
      deleteAccessPath: "Service Integration.Payment Integration - Delete",
      component: PageComponent.PaymentIntegration,
    },
  ],
}

const createTaxRoutes = {
  id: "Create Tax",
  path: "/configuration/taxProvider/create",
  readAccessPath: "Service Integration.Tax Integration - Read",
  writeAccessPath: "Service Integration.Tax Integration - Write",
  deleteAccessPath: "Service Integration.Tax Integration - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEditTax,
  children: null,
}
const editUserTaxRoutes = {
  id: "Edit Tax",
  path: "/configuration/taxProvider/view/:taxID",
  readAccessPath: "Service Integration.Tax Integration - Read",
  writeAccessPath: "Service Integration.Tax Integration - Write",
  deleteAccessPath: "Service Integration.Tax Integration - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateEditTax,
  children: null,
}

/**
 *@Log Viewer
 */

const logViewerRoutes = {
  id: "Log Viewer",
  path: "/logviewer",
  name: "Log Viewer",
  icon: <LogViewerIcon />,
  readAccessPath: "",
  writeAccessPath: "",
  deleteAccessPath: "",
  childArray: [{ readAccessPath: "Log Viewer - Read" }],
  children: [
    {
      path: "/logviewer/auditLog",
      name: "Audit Logs",
      readAccessPath: "Log Viewer.Audit Logs - Read",
      writeAccessPath: "Log Viewer.Audit Logs - Write",
      deleteAccessPath: "Log Viewer.Audit Logs - Delete",
      component: PageComponent.AuditLog,
    },
    {
      path: "/logviewer/applicationlog",
      name: "Application Logs",
      readAccessPath: "Log Viewer.Application Logs - Read",
      writeAccessPath: "Log Viewer.Application Logs - Write",
      deleteAccessPath: "Log Viewer.Application Logs - Delete",
      component: PageComponent.ApplicationLog,
    },
  ],
}
/**
 *@Connector settings View
 */
const settingssRoutes = {
  id: "Connector Settings",
  path: "/connectorSettings",
  name: "Connector Settings ",
  icon: <Monitor />,
  childArray: [{ readAccessPath: "Connector Settings - Read" }],
  children: [
    {
      path: "/connectorSettings/PaymentGatewayConfig",
      name: "Payment Gateway Config",
      readAccessPath: "Connector Settings.Payment Gateway Config - Read",
      writeAccessPath: "Connector Settings.Payment Gateway Config - Write",
      deleteAccessPath: "Connector Settings.Payment Gateway Config - Delete",
      component: PageComponent.PaymentGatewayConfigLanding,
    },
  ],
  component: null,
}

const PerPaymentGatewayConfigRoutes = {
  id: "SalesReports",
  path: "/connectorSettings/PaymentGatewayConfig/:tenantId",
  readAccessPath: "Connector Settings.Payment Gateway Config - Read",
  writeAccessPath: "Connector Settings.Payment Gateway Config - Write",
  deleteAccessPath: "Connector Settings.Payment Gateway Config - Delete",
  component: PageComponent.PaymentGatewayConfig,
  children: null,
}

/**
 *@Profile Update
 */
const profileUpdateRoutes = {
  id: "Profile Update",
  path: "/profileUpdate/:userID",
  component: PageComponent.ProfileUpdate,
  readAccessPath: "Dashboard - Read",
  writeAccessPath: "Dashboard - Write",
  deleteAccessPath: "Dashboard - Delete",
  children: null,
}

/**
 *@Frictionless store
 */

const createDeviceFS = {
  id: "createDeviceFS",
  path: "/frictionless-store/sdc/device-management/create/:LocationNum",
  readAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Read",
  writeAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Write",
  deleteAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateDeviceMgmtPage,
  children: null,
}

const editDeviceFS = {
  id: "editDeviceFS",
  path:
    "/frictionless-store/sdc/device-management/device-details/:LocationNum/:deviceId",
  readAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Read",
  writeAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Write",
  deleteAccessPath:
    "Frictionless Store.Smart Device Configuration - Device Management - Delete",
  icon: <Monitor />,
  component: PageComponent.EditDeviceMgmtPage,
  children: null,
}

const CreateFSEdgeDeviceRoutes = {
  id: "createEdgeDevice",
  path: "/frictionless-store/sdc/edgeDevice/create/:LocationNum",
  readAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Read",
  writeAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Write",
  deleteAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Delete",
  icon: <Monitor />,
  component: PageComponent.CreateFSEdgeDeviceDetails,
  children: null,
}

const EditFSEdgeDeviceRoutes = {
  id: "editEdgeDevice",
  path:
    "/frictionless-store/sdc/edgeDevice/edgeDeviceDetails/:LocationNum/:edgeDeviceId",
  readAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Read",
  writeAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Write",
  deleteAccessPath:
    "Frictionless Store.Smart Device Configuration - Edge Devices - Delete",
  icon: <Monitor />,
  component: PageComponent.EditFSEdgeDeviceDetails,
  children: null,
}

const maintainFrictionlessStore = {
  path: "/frictionless-store/planogram/maintainFrictionlessStore/:locationID",
  readAccessPath:
    "Frictionless Store.Planogram - Maintenance and Management - Read	",
  name: "Maintain Frictionless Store",
  icon: <Monitor />,
  component: PageComponent.FrictionlessStore,
  children: null,
}

let inventoryLogReport = isTenantAdminForceDisable
  ? {}
  : {
    path: "/reports/inventoryLogReport",
    name: "Inventory Log Report",
    component: PageComponent.InventoryLogReport,
    readAccessPath: "Reports.Inventory Report - Read",
  }

const reportsRoutes = {
  id: "Reports",
  path: "/reports",
  icon: <Monitor />,
  childArray: [{ readAccessPath: "Reports - Read" }],
  children: [
    {
      path: "/reports/salesSummaryReport",
      name: "Sales Report",
      component: PageComponent.SalesSummaryReportLanding,
      readAccessPath: "Reports.Sales Report - Read",
      writeAccessPath: "Reports.Sales Report - Write",
      deleteAccessPath: "Reports.Sales Report - Delete",
    },
    {
      path: "/reports/inventoryReport",
      name: "Inventory Report",
      component: PageComponent.InventoryReportLanding,
      readAccessPath: "Reports.Inventory Report - Read",
      writeAccessPath: "Reports.Inventory Report - Write",
      deleteAccessPath: "Reports.Inventory Report - Delete",
    },
    inventoryLogReport,
  ],
  component: null,
}

const PerTenantSalesReportsRoutes = {
  id: "SalesReports",
  path: "/reports/salesSummaryReport/:tenantId",
  readAccessPath: "Reports.Sales Report - Read",
  writeAccessPath: "Reports.Sales Report - Write",
  deleteAccessPath: "Reports.Sales Report - Delete",
  component: PageComponent.SalesSummaryReport,
  children: null,
}
const PerTenantInventoryReportsRoutes = {
  id: "InventoryReports",
  path: "/reports/inventoryReport/:tenantId",
  readAccessPath: "Reports.Inventory Report - Read",
  writeAccessPath: "Reports.Inventory Report - Write",
  deleteAccessPath: "Reports.Inventory Report - Delete",
  component: PageComponent.InventoryReport,
  children: null,
}

/**
 *@Alerts
 */

const alertRoutes = {
  id: "Alerts",
  path: "/alert",
  icon: <AlertIconKit />,
  childArray: [{ readAccessPath: "Alerts - Read" }],
  children: [
    {
      path: "/alert/newAlert",
      name: "Alerts Hub",
      component: PageComponent.NewAlertLanding,
      readAccessPath: "Alerts.Alerts Hub - Read",
      writeAccessPath: "Alerts.Alerts Hub - Write",
      deleteAccessPath: "Alerts.Alerts Hub - Delete",
    },
    {
      path: "/alert/configuration",
      name: "Subscription",
      component: PageComponent.AlertsLanding,
      readAccessPath: "Alerts.Subscription - Read",
      writeAccessPath: "Alerts.Subscription - Write",
      deleteAccessPath: "Alerts.Subscription - Delete",
    },
    {
      path: "/alert/monitor",
      name: "Monitor",
      component: PageComponent.AlertsLanding,
      readAccessPath: "Alerts.Monitor - Read",
      writeAccessPath: "Alerts.Monitor - Write",
      deleteAccessPath: "Alerts.Monitor - Delete",
    },
  ],
  component: null,
}

const PerTenantAlertsHubsRoutes = {
  id: "AlertsHubs",

  path: "/alert/newAlert/:tenantId",
  readAccessPath: "Alerts.Alerts Hub - Read",
  writeAccessPath: "Alerts.Alerts Hub - Write",
  deleteAccessPath: "Alerts.Alerts Hub - Delete",
  component: PageComponent.NewAlert,
  children: null,
}

const PerTenantAlertsSubscriptionRoutes = {
  id: "AlertsSubscription",
  path: "/alert/newAlert/:tenantId",
  readAccessPath: "Alerts.Subscription - Read",
  writeAccessPath: "Alerts.Subscription - Write",
  deleteAccessPath: "Alerts.Subscription - Delete",
  component: PageComponent.Alerts,
  children: null,
}

const PerTenantAlertsMonitorRoutes = {
  id: "AlertsMonitor",
  path: "/alert/monitor/:tenantId",
  readAccessPath: "Alerts.Monitor - Read",
  writeAccessPath: "Alerts.Monitor - Write",
  deleteAccessPath: "Alerts.Monitor - Delete",
  component: PageComponent.Alerts,
  children: null,
}
const alertconfigurationRoutes = {
  path: "/alert/configuration/:tenantId",
  name: "Configuration",
  component: PageComponent.Configuration,
  readAccessPath: "Alerts.Subscription - Read",
  writeAccessPath: "Alerts.Subscription - Write",
  deleteAccessPath: "Alerts.Subscription - Delete",
}

const alertmonitorRoutes = {
  path: "/alert/monitor/:tenantId/:severity?/:locationId?",
  name: "Monitor",
  component: PageComponent.Monitor,
  readAccessPath: "Alerts.Monitor - Read",
  writeAccessPath: "Alerts.Monitor - Write",
  deleteAccessPath: "Alerts.Monitor - Delete",
}

/**
 *@Forget password
 */

const forgetPassword = {
  id: "Forget password page",
  path: "/forgetpassword",
  icon: null,
  component: PageComponent.ForgetPassword,
  children: null,
}

const spacePlanningRoutes = {
  path: "/spacePlanning/planogramList",
  id: "View Monitoring",
  component: PageComponent.SpacePlanningList,
  readAccessPath:
    "Master Data - Smart Device Configuration.Planogram - Maintenance and Management - Read",
  icon: <PlanogramIcon />,
  children: null,
}

const liveMonitoringRoutes = {
  id: "Monitoring",
  path: "/livemonitoring",
  readAccessPath: "Live Monitoring - Read",
  writeAccessPath: "Live Monitoring - Write",
  deleteAccessPath: "Live Monitoring - Delete",
  icon: <EqualizerOutlined />,
  component: null,
  children: [
    {
      id: "Products",
      name: "Products",
      readAccessPath: "",
      writeAccessPath: "",
      icon: "",
      component: PageComponent.MonitoringProducts,
      redirect: false,
      path: "/livemonitoring/products",
    },

    {
      id: "Devices",
      name: "Devices",
      readAccessPath: "",
      writeAccessPath: "",
      deleteAccessPath: "",
      icon: "",
      component: null,
      redirect: false,
      path: "/frictionless-store/sdc",
    },

    {
      id: "Incidents",
      name: "Incidents",
      readAccessPath: "",
      writeAccessPath: "",
      deleteAccessPath: "",
      icon: "",
      component: null,
      redirect: false,
      path: "/frictionless-store/sdc",
    },
  ],
}

const liveMonitoringProductDetailedScreenRoutes = {
  path: "/livemonitoring/products/product-detailed-page/:id",
  readAccessPath: "Master Data.Products - Read",
  writeAccessPath: "Master Data.Products - Write",
  deleteAccessPath: "Master Data.Products - Delete",
  component: PageComponent.EditLiveMonitoringProduct,
}

const EqipmentDetials = {
  id: "EquipmentDetials",
  path: "/eqipmentList/storeEquipmentDetails",
  icon: <Cpu />,
  component: PageComponent.StoreEquipmentDetails,
  children: null,
}

const equipmentList = {
  id: "EquipmentList",
  path: "/eqipmentList",
  icon: <Cpu />,
  component: PageComponent.EquipmentList,
  children: null,
}

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: PageComponent.SignIn,
    },
    {
      path: "/auth/sign-up",
      name: "Sign Up",
      component: PageComponent.SignUp,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: PageComponent.ResetPassword,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: PageComponent.Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: PageComponent.Page500,
    },
    {
      path: "/auth/forgetpassword",
      name: "forget password",
      component: PageComponent.ForgetPassword,
    },
    {
      path: "/auth/403",
      name: "403 Page",
      component: PageComponent.Page403,
    },
  ],
  component: null,
}

const landingRoutes = {
  id: "Landing Page",
  path: "/",
  icon: <Monitor />,
  component: PageComponent.SignIn,
  children: null,
}

const proflieRoutes = {
  id: "Edit Profile",
  path: "/edit-profile",
  icon: <Monitor />,
  component: PageComponent.EditProfile,
  children: null,
}

const settingsRoutes = {
  id: "Settings",
  path: "/settings",
  icon: <Monitor />,
  component: PageComponent.Settings,
  children: null,
}

const helpRoutes = {
  id: "Help",
  path: "/help",
  icon: <Monitor />,
  component: PageComponent.Help,
  children: null,
}
const loginRoutes = {
  id: "Login",
  path: "/help",
  component: PageComponent.Login,
  children: null,
}

const supportRoutes = {
  id: "Help",
  path: "/support",
  icon: <Monitor />,
  component: PageComponent.Support,
  children: null,
}

const privacyRoutes = {
  id: "Help",
  path: "/privacy",
  icon: <Monitor />,
  component: PageComponent.Privacy,
  children: null,
}

const termsOfServiceRoutes = {
  id: "Help",
  path: "/terms-of-service",
  icon: <Monitor />,
  component: PageComponent.TermsOfService,
  children: null,
}

const statusRoutes = {
  id: "Status",
  path: "/status",
  icon: <Layout />,
  component: PageComponent.Status,
  children: null,
}

const masterDataRoutes = {
  id: "Master Data",
  path: "/master-data",
  readAccessPath: "",
  writeAccessPath: "",
  deleteAccessPath: "",
  icon: <List />,
  childArray: [
    {
      readAccessPath: "Master Data - Read",
    },
  ],
  children: [
    {
      path: "/master-data/storage/Vendorslist",
      name: "Vendors",
      id: "Vendors",
      readAccessPath: "Master Data.Vendors - Read",
      writeAccessPath: "Master Data.Vendors - Write",
      deleteAccessPath: "Master Data.Vendors - Delete",
      component: PageComponent.VendorsLanding,
      skipChildArray: true,
    },
    {
      path: "/master-data/storage/storageunit",
      name: "Storage",
      id: "Vendors",
      readAccessPath: "Master Data.Storage - Read",
      writeAccessPath: "Master Data.Storage - Write",
      deleteAccessPath: "Master Data.Storage - Delete",
      component: PageComponent.LocationsProductStorageLanding,
    },
    {
      path: "/master-data/locations",
      name: "Stores",
      id: "Stores",
      readAccessPath: "Master Data.Stores - Read",
      writeAccessPath: "Master Data.Stores - Write",
      deleteAccessPath: "Master Data.Stores - Delete",
      component: PageComponent.LocationsLanding,
    },
    {
      name: "Store Groups",
      path: "/master-data/locations_g/groups",
      id: "Store Group",
      component: PageComponent.GroupsLanding,
      readAccessPath: "Master Data.Store Group - Read",
      writeAccessPath: "Master Data.Store Group - Write",
      deleteAccessPath: "Master Data.Store Group - Delete",
    },
    {
      name: "Store Hierarchy",
      id: "Store Hierarchy",
      path: "/master-data/locations_h/hierarchy",
      readAccessPath: "Master Data.Store Hierarchy - Read",
      writeAccessPath: "Master Data.Store Hierarchy - Write",
      deleteAccessPath: "Master Data.Store Hierarchy - Delete",
      component: PageComponent.HierarchyLanding,
    },
    {
      path: "/master-data/locations_hm/hierarchyMapping",
      name: "Store Hierarchy Mapping",
      id: "Store Hierarchy Mapping",
      readAccessPath: "Master Data.Store Hierarchy Mapping - Read",
      writeAccessPath: "Master Data.Store Hierarchy Mapping - Write",
      deleteAccessPath: "Master Data.Store Hierarchy Mapping - Delete",
      component: PageComponent.HierarchyMappingLanding,
    },
    {
      path: "/master-data/products",
      name: "Products",
      id: "Products",
      readAccessPath: "Master Data.Products - Read",
      writeAccessPath: "Master Data.Products - Write",
      deleteAccessPath: "Master Data.Products - Delete",
      component: PageComponent.ProductsLanding,
    },
    {
      path: "/master-data/products_g/groups",
      name: "Products Groups",
      id: "Products Groups",
      readAccessPath: "Master Data.Product Group - Read",
      writeAccessPath: "Master Data.Product Group - Write",
      deleteAccessPath: "Master Data.Product Group - Delete",
      component: PageComponent.ProductsGroupsLanding,
    },
    {
      path: "/master-data/products_h/hierarchy",
      name: "Product Category",
      id: "Product Category",
      readAccessPath: "Master Data.Product Category - Read",
      writeAccessPath: "Master Data.Product Category - Write",
      deleteAccessPath: "Master Data.Product Category - Delete",
      component: PageComponent.ProductDataHierarchyLanding,
    },
    {
      path: "/master-data/products_pm/productMapping",
      name: "Product Category Mapping",
      id: "Product Category Mapping",
      readAccessPath: "Master Data.Product Category Mapping - Read",
      writeAccessPath: "Master Data.Product Category Mapping - Write",
      deleteAccessPath: "Master Data.Product Category Mapping - Delete",
      component: PageComponent.HierarchyMappingLanding,
    },
    {
      path: "/master-data/products_attr/attribute",
      name: "Product Attributes",
      id: "Product Attributes",
      readAccessPath: "Master Data.Product Attributes - Read",
      writeAccessPath: "Master Data.Product Attributes - Write",
      deleteAccessPath: "Master Data.Product Attributes - Delete",
      component: PageComponent.ProductAttributeLanding,
    },
    {
      path: "/master-data/offers",
      name: "Promotional Offers",
      icon: "",
      id: "Offers",
      readAccessPath: "Master Data.Promotional Offers - Read",
      writeAccessPath: "Master Data.Promotional Offers - Write",
      deleteAccessPath: "Master Data.Promotional Offers - Delete",
      component: PageComponent.OffersLanding,
      skipChildArray: true,
    },
    {
      path: "/master-data/discounts",
      name: "Discounts",
      icon: "",
      id: "Discounts",
      readAccessPath: "Master Data.Discounts - Read",
      writeAccessPath: "Master Data.Discounts - Write",
      deleteAccessPath: "Master Data.Discounts - Delete",
      component: PageComponent.discountsLanding,
      skipChildArray: true,
    },
  ],
  component: null,
}

const PerTenantMasterDataStoreUnitRoutes = {
  id: "PerTenantMasterDataStoreUnitRoutes",
  path: "/master-data/locations/:tenantId",
  readAccessPath: "Master Data.Stores - Read",
  writeAccessPath: "Master Data.Stores - Write",
  deleteAccessPath: "Master Data.Stores - Delete",
  component: PageComponent.Locations,
  children: null,
}
const PerTenantMasterDataStoreGroupsRoutes = {
  id: "PerTenantMasterDataStoreGroupsRoutes",
  path: "/master-data/locations_g/groups/:tenantId",
  readAccessPath: "Master Data.Store Group - Read",
  writeAccessPath: "Master Data.Store Group - Write",
  deleteAccessPath: "Master Data.Store Group - Delete",
  component: PageComponent.Groups,
  children: null,
}
const PerTenantMasterDataStoreHierarchyRoutes = {
  id: "PerTenantMasterDataStoreHierarchyRoutes",
  path: "/master-data/locations_h/hierarchy/:tenantId",
  readAccessPath: "Master Data.Store Hierarchy - Read",
  writeAccessPath: "Master Data.Store Hierarchy - Write",
  deleteAccessPath: "Master Data.Store Hierarchy - Delete",
  component: PageComponent.Hierarchy,
  children: null,
}
const PerTenantMasterDataStoreHierarchyMappingRoutes = {
  id: "PerTenantMasterDataStoreHierarchyMappingRoutes",
  path: "/master-data/locations_hm/hierarchyMapping/:tenantId",
  readAccessPath: "Master Data.Store Hierarchy Mapping - Read",
  writeAccessPath: "Master Data.Store Hierarchy Mapping - Write",
  deleteAccessPath: "Master Data.Store Hierarchy Mapping - Delete",
  component: PageComponent.HierarchyMapping,
  children: null,
}
const PerTenantMasterDataProductsUnitsRoutes = {
  id: "PerTenantMasterDataProductsUnitsRoutes",
  path: "/master-data/products/:tenantId",
  readAccessPath: "Master Data.Products - Read",
  writeAccessPath: "Master Data.Products - Write",
  deleteAccessPath: "Master Data.Products - Delete",
  component: PageComponent.Products,
  children: null,
}
const PerTenantMasterDataProductsGroupsRoutes = {
  id: "PerTenantMasterDataProductsGroupsRoutes",
  path: "/master-data/products_g/groups/:tenantId",
  readAccessPath: "Master Data.Product Group - Read",
  writeAccessPath: "Master Data.Product Group - Write",
  deleteAccessPath: "Master Data.Product Group - Delete",
  component: PageComponent.ProductsGroups,
  children: null,
}
const PerTenantMasterDataProductDataHierarchyRoutes = {
  id: "PerTenantMasterDataProductDataHierarchyRoutes",
  path: "/master-data/products_h/hierarchy/:tenantId",
  readAccessPath: "Master Data.Product Category - Read",
  writeAccessPath: "Master Data.Product Category - Write",
  deleteAccessPath: "Master Data.Product Category - Delete",
  component: PageComponent.ProductDataHierarchy,
  children: null,
}
const PerTenantMasterDataProductHierarchyMappingRoutes = {
  id: "PerTenantMasterDataProductHierarchyMappingRoutes",
  path: "/master-data/products_pm/productMapping/:tenantId",
  readAccessPath: "Master Data.Product Category Mapping - Read",
  writeAccessPath: "Master Data.Product Category Mapping - Write",
  deleteAccessPath: "Master Data.Product Category Mapping - Delete",
  component: PageComponent.HierarchyMapping,
  children: null,
}
const PerTenantMasterDataProductAttributeRoutes = {
  id: "PerTenantMasterDataProductAttributeRoutes",
  path: "/master-data/products_attr/attribute/:tenantId",
  readAccessPath: "Master Data.Product Attributes - Read",
  writeAccessPath: "Master Data.Product Attributes - Write",
  deleteAccessPath: "Master Data.Product Attributes - Delete",
  component: PageComponent.ProductAttribute,
  children: null,
}

const PerTenantMasterDataPromotionalOffersRoutes = {
  id: "PromotionalOffers",
  path: "/master-data/offers/:tenantId",
  readAccessPath: "Master Data.Promotional Offers - Read",
  writeAccessPath: "Master Data.Promotional Offers - Write",
  deleteAccessPath: "Master Data.Promotional Offers - Delete",
  component: PageComponent.Offers,
  children: null,
}
const PerTenantMasterDataDiscountRoutes = {
  id: "MDiscount",
  path: "/master-data/discounts/:tenantId",
  readAccessPath: "Master Data.Discounts - Read",
  writeAccessPath: "Master Data.Discounts - Write",
  deleteAccessPath: "Master Data.Discounts - Delete",
  component: PageComponent.discounts,
  children: null,
}
const PerTenantMasterDataStorageVendorRoutes = {
  id: "MStorageVendors",
  path: "/master-data/storage/Vendorslist/:tenantId",
  readAccessPath: "Master Data.Vendors - Read",
  writeAccessPath: "Master Data.Vendors - Write",
  deleteAccessPath: "Master Data.Vendors - Delete",
  component: PageComponent.Vendors,
  children: null,
}
const PerTenantMasterDataStorageUnitRoutes = {
  id: "MStorageUnits",
  path: "/master-data/storage/storageunit/:tenantId",
  readAccessPath: "Master Data.Storage - Read",
  writeAccessPath: "Master Data.Storage - Write",
  deleteAccessPath: "Master Data.Storage - Delete",
  component: PageComponent.LocationsProductStorage,
  children: null,
}

let cycleCountValue = {
  path: "/inventory/store/cycleCounts",
  name: "Cycle Counts",
  readAccessPath: "Master Data.Inventory Adjustments - Read",
  writeAccessPath: "Master Data.Inventory Adjustments - Write",
  deleteAccessPath: "Master Data.Inventory Adjustments - Delete",
  component: PageComponent.InventoryCycleCounts,
}

let CycleCounts = isTenantAdminForceDisable
  ? localStorage.getItem("Enable_Module_Inventory_Cycle_Counts") === "ON"
    ? cycleCountValue
    : {}
  : cycleCountValue

const inventoryPurchaseViewHistoryDetailRoutes = {
  path:
    "/inventory/store/purchase/product_mapping/storeId=:id/view-history/:historyId",
  readAccessPath: "Store Inventory.Purchases - Read",
  writeAccessPath: "Store Inventory.Purchases - Write",
  deleteAccessPath: "Store Inventory.Purchases - Delete",
  component: PageComponent.PurchaseViewHistoryDetail,
}

const inventoryPurchaseViewHistoryRoutes = {
  path:
    "/inventory/store/purchase/product_mapping/storeId=:id/view-history",
  readAccessPath: "Store Inventory.Purchases - Read",
  writeAccessPath: "Store Inventory.Purchases - Write",
  deleteAccessPath: "Store Inventory.Purchases - Delete",
  component: PageComponent.PurchaseViewHistory,
}

const inventoryLocationPurchaseDetailedScreenRoutes = {
  path: "/inventory/store/purchase/product_mapping/storeId=:id?",
  readAccessPath: "Store Inventory.Purchases - Read",
  writeAccessPath: "Store Inventory.Purchases - Write",
  deleteAccessPath: "Store Inventory.Purchases - Delete",
  component: PageComponent.LocationTabLandingPagePurchase,
}

const storeInventoryDataRoutes = {
  id: "Store Inventory",
  path: "/inventory",
  readAccessPath: "",
  icon: <BarChartIcon />,
  childArray: [{ readAccessPath: "Store Inventory - Read" }],
  children: [
    {
      path: "/inventory/store/inventory",
      name: "INV Snapshot",
      readAccessPath: "Store Inventory.INV Snapshot - Read",
      writeAccessPath: "Store Inventory.INV Snapshot - Write",
      deleteAccessPath: "Store Inventory.INV Snapshot - Delete",
      component: PageComponent.InventoryLanding,
    },
    {
      path: "/inventory/store/adjustments",
      name: "Adjustments",
      readAccessPath: "Store Inventory.Adjustments - Read",
      writeAccessPath: "Store Inventory.Adjustments - Write",
      deleteAccessPath: "Store Inventory.Adjustments - Delete",
      component: PageComponent.InventoryAdjustmentsLanding,
    },
    {
      path: "/inventory/store/suppliers",
      name: "Suppliers",
      readAccessPath: "Store Inventory.Suppliers - Read",
      writeAccessPath: "Store Inventory.Suppliers - Write",
      deleteAccessPath: "Store Inventory.Suppliers - Delete",
      component: PageComponent.InventorySuppliersLanding,
    },
    {
      path: "/inventory/store/purchase",
      name: "Purchases",
      readAccessPath: "Store Inventory.Purchases - Read",
      writeAccessPath: "Store Inventory.Purchases - Write",
      deleteAccessPath: "Store Inventory.Purchases - Delete",
      component: PageComponent.InventoryBulkProductPurchaseLanding,
    },
    {
      path: "/inventory/store/purchases_history",
      name: "Purchase History",
      readAccessPath: "Store Inventory.Purchase - Read",
      writeAccessPath: "Store Inventory.Purchase - Write",
      deleteAccessPath: "Store Inventory.Purchase - Delete",
      component: PageComponent.InventoryPurchaseLanding,
    },
    CycleCounts,
    {
      path: "/inventory/store/inventoryLogs",
      name: "Inventory Logs",
      readAccessPath: "Store Inventory.Inventory Logs - Read",
      writeAccessPath: "Store Inventory.Inventory Logs - Write",
      deleteAccessPath: "Store Inventory.Inventory Logs - Delete",
      component: PageComponent.InventoryLogs,
    },
    {
      path: "/inventory/store/stock_report",
      name: "Stock Report",
      readAccessPath: "Store Inventory.Stock Report - Read",
      writeAccessPath: "Store Inventory.Stock Report - Write",
      deleteAccessPath: "Store Inventory.Stock Report - Delete",
      component: PageComponent.InventoryStockReportLanding,
    },
  ],
}

const PerTenantStoreStockReportRoutes = {
  id: "Stock Report",
  path: "/inventory/store/stock_report/:tenantId",
  readAccessPath: "Store Inventory.Stock Report - Read",
  writeAccessPath: "Store Inventory.Stock Report - Write",
  deleteAccessPath: "Store Inventory.Stock Report - Delete",
  component: PageComponent.InventoryStockReport,
  children: null,
}
const PerTenantStorePurchaseHistoryRoutes = {
  id: "PurchaseHistory",
  path: "/inventory/store/purchases_history/:tenantId",
  readAccessPath: "Store Inventory.Purchase - Read",
  writeAccessPath: "Store Inventory.Purchase - Write",
  deleteAccessPath: "Store Inventory.Purchase - Delete",
  component: PageComponent.InventoryPurchase,
  children: null,
}
const PerTenantStorePurchaseRoutes = {
  id: "storePurchases",
  path: "/inventory/store/purchase/:tenantId",
  readAccessPath: "Store Inventory.Purchases - Read",
  writeAccessPath: "Store Inventory.Purchases - Write",
  deleteAccessPath: "Store Inventory.Purchases - Delete",
  component: PageComponent.InventoryBulkProductPurchase,
  children: null,
}
const PerTenantStoresuppliersRoutes = {
  id: "storesuppliers",
  path: "/inventory/store/suppliers/:tenantId",
  readAccessPath: "Store Inventory.Suppliers - Read",
  writeAccessPath: "Store Inventory.Suppliers - Write",
  deleteAccessPath: "Store Inventory.Suppliers - Delete",
  component: PageComponent.InventorySuppliers,
  children: null,
}
const PerTenantStoreAdjustmentssRoutes = {
  id: "StoreAdjustments",
  path: "/inventory/store/adjustments/:tenantId",
  readAccessPath: "Store Inventory.Adjustments - Read",
  writeAccessPath: "Store Inventory.Adjustments - Write",
  deleteAccessPath: "Store Inventory.Adjustments - Delete",
  component: PageComponent.InventoryAdjustments,
  children: null,
}
const PerTenantStoreINVSnapshotsRoutes = {
  id: "StoreINVSnapshot",
  path: "/inventory/store/inventory/:tenantId",
  readAccessPath: "Store Inventory.INV Snapshot - Read",
  writeAccessPath: "Store Inventory.INV Snapshot - Write",
  deleteAccessPath: "Store Inventory.INV Snapshot - Delete",
  component: PageComponent.Inventory,
  children: null,
}

const storageInventoryDataRoutes = {
  id: "Storage Inventory",
  path: "/inventory_storage",
  readAccessPath: "",
  icon: <BarChartIcon />,
  childArray: [{ readAccessPath: "Storage Inventory - Read" }],
  children: [
    {
      path: "/inventory_storage/storage/inventory",
      name: "INV Snapshot",
      readAccessPath: "Storage Inventory.INV Snapshot - Read",
      writeAccessPath: "Storage Inventory.INV Snapshot - Write",
      deleteAccessPath: "Storage Inventory.INV Snapshot - Delete",
      component: PageComponent.InventoryStorageLanding,
    },
    {
      path: "/inventory_storage/storage/adjustments",
      name: "Adjustments",
      readAccessPath: "Storage Inventory.Adjustments - Read",
      writeAccessPath: "Storage Inventory.Adjustments - Write",
      deleteAccessPath: "Storage Inventory.Adjustments - Delete",
      component: PageComponent.InventoryStorageAdjustmentsLanding,
    },
  ],
}

const PerTenantStorageINVSnapshotsRoutes = {
  id: "StorageINVSnapshot",
  path: "/inventory_storage/storage/inventory/:tenantId",
  readAccessPath: "Storage Inventory.INV Snapshot - Read",
  writeAccessPath: "Storage Inventory.INV Snapshot - Write",
  deleteAccessPath: "Storage Inventory.INV Snapshot - Delete",
  component: PageComponent.InventoryStorage,
  children: null,
}
const PerTenantStorageAdjustmentsRoutes = {
  id: "StorageAdjustments",
  path: "/inventory_storage/storage/adjustments/:tenantId",
  readAccessPath: "Storage Inventory.Adjustments - Read",
  writeAccessPath: "Storage Inventory.Adjustments - Write",
  deleteAccessPath: "Storage Inventory.Adjustments - Delete",
  component: PageComponent.InventoryStorageAdjustments,
  children: null,
}

const InventoryPurchaseCreate = {
  path: "/inventory/store/purchases_history/create",
  readAccessPath: "Store Inventory.Purchase - Read",
  writeAccessPath: "Store Inventory.Purchase - Write",
  deleteAccessPath: "Store Inventory.Purchase - Delete",
  component: PageComponent.InventoryPurchaseCreate,
}

const InventoryPurchaseEdit = {
  path: "/inventory/store/purchases_history/edit/:_id",
  readAccessPath: "Store Inventory.Purchase - Read",
  writeAccessPath: "Store Inventory.Purchase - Write",
  deleteAccessPath: "Store Inventory.Purchase - Delete",
  component: PageComponent.InventoryPurchaseCreate,
}

/**
 *@oldDashboardsRoutes
 */
const sidebarRoute = [
  dashboardsRoutes,
  contentRoutes,
  masterDataRoutes,
  storeInventoryDataRoutes,
  storageInventoryDataRoutes,
  autonomousStoreRoutes,
  planogramRoutes,
  liveMonitoringSplitRoutes,
  transactionsRoutes,
  reportsRoutes,
  alertRoutes,
  userManagementRoutes,
  serviceIntergrationRoutes,
  logViewerRoutes,
  settingsRoutes,
  settingssRoutes,
  tenantRoutes,
  tenantSettingsRoutes,
  employeeDetails,
  // subSaaSAdminSettingsRoutes,
]

const dashboardLayout = [
  oldDashboardsRoutes,
  createEditPlatformAccountConfig,
  dashboardsRoutes,
  planogramDetailRoutes,
  spacePlanningRoutes,
  contentRoutes,
  masterDataRoutes,
  storeInventoryDataRoutes,
  storageInventoryDataRoutes,
  transactionsRoutes,
  transactionsStoresRoutes,
  AutomatedTenantTransactionsOrder,
  HITLTenantTransactionsOrder,
  DisputedTenantTransactionsOrder,
  AllTenantTransactionsOrder,
  storeTransactionsRoutes,
  liveMonitoringRoutes,
  userManagementRoutes,
  proflieRoutes,
  helpRoutes,
  loginRoutes,
  settingsRoutes,
  privacyRoutes,
  supportRoutes,
  termsOfServiceRoutes,
  createUpdateStorageRoutes,
  createLocationRoutes,
  createPosRoutes,
  rolePermissionRoutes,
  subsassPermissionRoutes,
  tenantPermissionRoutes,
  liveMonitoringProductDetailedScreenRoutes,
  masterDataLocationDetailedScreenRoutes,
  inventoryPurchaseViewHistoryDetailRoutes,
  inventoryPurchaseViewHistoryRoutes,
  inventoryLocationPurchaseDetailedScreenRoutes,
  masterDataLocationGroupDetailedScreenRoutes,
  masterDataCustomerDetailedScreenRoutes,
  masterDataProductDetailedScreenRoutes,
  masterDataProductGroupDetailedScreenRoutes,
  masterDataPriceDetailedScreenRoutes,
  masterDataInventoryDetailedScreenRoutes,
  masterDataAddNewAddressScreenRoutes,
  statusRoutes,
  createCustomerRoutes,
  createProductRoutes,
  editProductRoutes,
  createInventoryRoutes,
  createPriceRoutes,
  GroupLocationsListRoutes,
  GroupProductCreateRoutes,
  createProductGroup,
  createEquipmentRoutes,
  EditOrderRoutes,
  CreateTurnstile,
  CreateEntryorExitGate,
  CreateSmartShelf,
  CreateCamera,
  CreateGondola,
  EditTurnstileRoutes,
  EditEntryorExitGateRoutes,
  EditGondolaRoutes,
  PerTenantMasterDataStoreUnitRoutes,
  PerTenantMasterDataStoreGroupsRoutes,
  PerTenantMasterDataStoreHierarchyRoutes,
  PerTenantMasterDataStoreHierarchyMappingRoutes,
  PerTenantMasterDataProductsUnitsRoutes,
  PerTenantMasterDataProductsGroupsRoutes,
  PerTenantMasterDataProductDataHierarchyRoutes,
  PerTenantMasterDataProductHierarchyMappingRoutes,
  PerTenantMasterDataProductAttributeRoutes,
  PerTenantMasterDataPromotionalOffersRoutes,
  PerTenantMasterDataDiscountRoutes,
  PerTenantMasterDataStorageVendorRoutes,
  PerTenantMasterDataStorageUnitRoutes,
  PerTenantStoreStockReportRoutes,
  InventoryPurchaseCreate,
  InventoryPurchaseEdit,
  PerTenantStorePurchaseHistoryRoutes,
  PerTenantStorePurchaseRoutes,
  PerTenantStoresuppliersRoutes,
  PerTenantStoreAdjustmentssRoutes,
  PerTenantStoreINVSnapshotsRoutes,
  PerTenantStorageINVSnapshotsRoutes,
  PerTenantStorageAdjustmentsRoutes,
  PerTenantEntryorExitGateRoutes,
  PerTenantPaymentReadersRoutes,
  PerTenantGondolasRoutes,
  PerTenantSmartShelfsRoutes,
  PerTenantCamerasRoutes,
  PerTenantPlanogramRoutes,
  PerTenantStoreDevicesRoutes,
  PerTenantLiveMonitoringRoutes,
  PerTenantSalesReportsRoutes,
  PerTenantInventoryReportsRoutes,
  PerTenantAlertsHubsRoutes,
  PerTenantAlertsSubscriptionRoutes,
  PerTenantAlertsMonitorRoutes,
  EditCameraRoutes,
  EditSmartShelfRoutes,
  equipmentList,
  EqipmentDetials,
  masterDataproductsGroups,
  masterDataproductsHierarchy,
  masterDataproductsMapping,
  masterDataLocationGroups,
  masterDataLocationHierarchy,
  masterDataLocationMapping,
  masterDataPosDetailedScreenRoutes,
  masterDataproductsAttribute,
  masterDataInventoryAdjustments,
  maintainPlanoGram,
  maintainFrictionlessStore,
  tenantRoutes,
  editTenantSettingsRoutes,
  editSubSAASSettingsRoutes,
  createEditPaymentConfig,
  tenantSettingsRoutes,
  subSaaSAdminSettingsRoutes,
  CreateFSEdgeDeviceRoutes,
  EditFSEdgeDeviceRoutes,
  createVendorsRoutes,
  updateVendorsRoutes,
  createUserRoutes,
  createTaxRoutes,
  editUserTaxRoutes,
  editUserRoutes,
  createTenantRoutes,
  editTenantRoutes,
  createDeviceFS,
  editDeviceFS,
  profileUpdateRoutes,
  serviceIntergrationRoutes,
  logViewerRoutes,
  alertconfigurationRoutes,
  alertmonitorRoutes,
  settingssRoutes,
  inventoryDetails,
  inventoryStorageDetails,
  adjustmentDetails,
  adjustmentStorageDetails,
  invetoryAdjustmentDetails,
  invetoryAdjustmentStorageDetails,
  invetoryCycleCountsDetails,
  transactionsRoutesAutomated,
  transactionsRoutesHITL,
  transactionsRoutesDisputed,
  transactionsRoutesAll,
  PerPaymentGatewayConfigRoutes,
]

export { dashboardLayout, authRoutes, landingRoutes, sidebarRoute }
